var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-news',{attrs:{"categoryList":_vm.categoryList,"title":"房县黄酒协会 | 会员入口"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }